var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBets24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ball",
    transform: "translate(-16.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29041",
    "data-name": "Group 29041",
    transform: "translate(16.416)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48233",
    "data-name": "Path 48233",
    d: "M16.655,132.756c-.39.322-.293.522.215.443a30.5,30.5,0,0,0,7.108-1.806c1.553-.763,2.1.275,1.58,1.073-.194.3-.064.462.286.37,2-.53,6.254-1.85,7.4-5.885.052-.184.068-.6-.091-.718l-.066-.048a6.03,6.03,0,0,1-3.651,2.158,7.8,7.8,0,0,1-4.4-.368,6.579,6.579,0,0,1-2.125-1.436,7.042,7.042,0,0,1-1.439-7.505,6.6,6.6,0,0,1,.652-1.152l-.057-.041c-.175-.127-.713.045-.875.187-.922.81-3.629,3.737-4.267,10.639-.031.34.182.462.478.273a1.037,1.037,0,0,1,1.318-.064C19.308,129.44,18.085,131.575,16.655,132.756Z",
    transform: "translate(-16.416 -115.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48234",
    "data-name": "Path 48234",
    d: "M267.968,12.69a6.345,6.345,0,1,0-6.345-6.345A6.331,6.331,0,0,0,267.968,12.69ZM273.687,6.9l.008.007a5.7,5.7,0,0,1-.425,1.674q-.11.26-.244.507h-.012l-1.658.247-.645.1-1.062-1.384-.028-.036.692-2.131,1.669-.548Zm-5.424-4.691,2.016-1.129.01-.006a5.736,5.736,0,0,1,1.748,1.2q.11.11.214.226l0,.01L271.8,4.774l-1.726.567-1.815-1.319V2.213Zm.953,6.243,1.039,1.354-.9,2.11,0,.011a5.8,5.8,0,0,1-2.772,0l0-.011-.9-2.11,1.039-1.354ZM263.9,2.276a5.736,5.736,0,0,1,1.748-1.2l.01.006,2.016,1.129V4.022l-1.714,1.245-.1.073-1.726-.567-.2-1.038-.241-1.224,0-.01Q263.788,2.386,263.9,2.276Zm-.989,6.816q-.134-.246-.244-.507a5.7,5.7,0,0,1-.425-1.674l.008-.007,1.7-1.568,1.669.548.692,2.131-1.09,1.42-2.3-.343Z",
    transform: "translate(-256.313)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBets24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_bets24x24.2a2dc0c1eed6d82cf6cf50f1ff44b26d.svg";